import { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './Explore.css';
import { ContentItem } from '../shared/components/slider/contentItem/ContentItem';
import LoadingSpinner from '../shared/components/UIElements/LoadingSpinner';
import { AuthContext } from '../shared/context/auth-context';
import { HeaderNavigation } from '../shared/headerNavigation/HeaderNavigation';
import { useHttpClient } from '../shared/hooks/http-hook';
import { useFocusScroll } from '../shared/hooks/useFocusScroll.ts';
import { useUserData } from '../shared/hooks/useUserData.ts';
import { getHealthAreas, getPages, getHelpPages } from '../shared/util/explore';
import SearchBar from './SearchBar';

function Explore() {
  const { t } = useTranslation();
  const { isLoading } = useHttpClient();
  const auth = useContext(AuthContext);
  const [noResults, setNoResults] = useState(false);
  const [media, setMedia] = useState();

  const { userData } = useUserData();

  const isPamUser = userData?.customFeatureClient?.toLowerCase() === 'pam';

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useFocusScroll();

  function renderContent() {
    if (media?.length > 0) {
      return (
        <div className="search_media_container">
          {media.map((mediaItem, index) => (
            <ContentItem key={index} slideContent={mediaItem} />
          ))}
        </div>
      );
    }

    if (noResults) {
      return (
        <div className="no-results">
          <span className="sr-only" role="alert">
            {t('EX020')} {t('EX021')}
          </span>
          <div className="tile-title">{t('EX020')}</div>
          <div className="tile-subtitle">{t('EX021')}</div>
        </div>
      );
    }

    return (
      <div className="search_tile_container">
        <h2 className="search_section_title">{t('explore.section.healthareas')}</h2>
        {getHealthAreas(t).map((item, index) => (
          <Link to={item.link} className="healthArea-tile explore-tile" key={index}>
            <div className="tile-title">{item.title}</div>
            <div className="tile-subtitle">{item.description}</div>
          </Link>
        ))}
        <h2 className="search_section_title">{t('explore.section.pages')}</h2>
        {getPages(t)
          .filter((item) => !(isPamUser && item.title.includes(t('explore.section.invite'))))
          .map((item, index) => (
            <Link to={item.link} className="explore-tile page-tile" key={index}>
              <div className="tile-title">{item.title}</div>
              <div className="tile-subtitle">{item.description}</div>
            </Link>
          ))}
        <h2 className="search_section_title">{t('explore.section.support')}</h2>
        <Link to="/support" className="explore-tile support-tile">
          <div className="tile-title">{t('explore.section.support')}</div>
          <div className="tile-subtitle">{t('explore.support.description')}</div>
        </Link>
        {isPamUser && (
          <Link to="/support/services" className="explore-tile support-tile">
            <div className="tile-title">{t('explore.support.services')}</div>
            <div className="tile-subtitle">{t('explore.support.services.description')}</div>
          </Link>
        )}
        <h2 className="search_section_title">{t('explore.section.help')}</h2>
        <Link to="/accessibility-statement" className="explore-tile help-tile">
          <div className="tile-title">{t('accessibility.statement.title')}</div>
          <div className="tile-subtitle">{t('accessibility.statement.description')}</div>
        </Link>
        {auth.clientName &&
          getHelpPages(t, auth.clientName).map((item, index) => (
            <a
              href={item.link}
              className="explore-tile help-tile"
              target="_blank"
              rel="noopener noreferrer"
              key={index}
            >
              <div className="tile-title">
                {item.title}
                <span className="sr-only">{t('external.link.newTab')}</span>
              </div>
            </a>
          ))}
      </div>
    );
  }

  return (
    <div id="main_container" className="foryou health-area platform explore">
      <div className="wrap-screen">
        {isLoading && <LoadingSpinner asOverlay />}
        {auth.isLoggedIn && (
          <>
            <HeaderNavigation />
            <SearchBar setMedia={setMedia} setNoResults={setNoResults} />
            {renderContent()}
          </>
        )}
      </div>
    </div>
  );
}
export default Explore;
